import styled from '@emotion/styled';

export const InputContainer = styled.div`
  width: 100%;
  max-width: 500px;
  min-width: 400px;
  height: 580px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  background: #ffffff;
  box-sizing: border-box;
  position: relative;
  padding: 24px;
  
  @media (max-width: 1200px) {
    max-width: 100%;
    min-width: 300px;
  }
`;

export const UploadOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  z-index: 10;
`;

export const UploadProgress = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px;
`;

export const ProgressBar = styled.div`
  width: 200px;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: ${({ progress }) => progress}%;
    background: linear-gradient(90deg, #6A42F2, #8b5cf6);
    border-radius: 4px;
    transition: width 0.3s ease;
  }
`;

export const ProgressText = styled.div`
  color: #6A42F2;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  text-align: center;
`;

export const FieldGroup = styled.div`
  margin-bottom: 24px;
`;

export const FieldLabel = styled.label`
  display: block;
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const FieldHint = styled.div`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  margin-top: 4px;
`;

export const TextInput = styled.input`
  width: 100%;
  height: 36px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #dddddd;
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #000000;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #6A42F2;
  }
  
  &::placeholder {
    color: #757575;
  }
  
  &:disabled {
    background: #f9fafb;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 80px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #dddddd;
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
  color: #000000;
  box-sizing: border-box;
  resize: vertical;
  transition: border-color 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #6A42F2;
  }
  
  &::placeholder {
    color: #757575;
  }
  
  &:disabled {
    background: #f9fafb;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const FileUploadArea = styled.div`
  width: 100%;
  min-height: 140px;
  border-radius: 8px;
  background: ${({ disabled }) => disabled ? '#f9fafb' : '#ffffff'};
  border: 2px dashed ${({ disabled }) => disabled ? '#cccccc' : '#dddddd'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  position: relative;
  padding: 20px;
  
  ${({ disabled }) => !disabled && `
    &:hover {
      border-color: #6A42F2;
      background: #f8f7ff;
    }
  `}
`;

export const UploadIcon = styled.div`
  font-size: 32px;
  margin-bottom: 8px;
  opacity: 0.7;
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
`;

export const UploadText = styled.div`
  color: #757575;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  text-align: center;
  word-break: break-all;
  max-width: 90%;
`;

export const FileDetails = styled.div`
  color: #999999;
  font-family: "Inter", sans-serif;
  font-size: 11px;
  line-height: 16px;
  font-weight: 400;
  text-align: center;
`;

export const HiddenFileInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  
  &:disabled {
    cursor: not-allowed;
  }
`;

export const ButtonGroup = styled.div`
  position: absolute;
  bottom: 24px;
  right: 24px;
  display: flex;
  gap: 12px;
`;

export const CancelButton = styled.button`
  width: 70px;
  height: 36px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #dddddd;
  cursor: pointer;
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    background: #f5f5f5;
    border-color: #cccccc;
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const UploadButton = styled.button`
  width: 90px;
  height: 36px;
  border-radius: 6px;
  background: ${({ disabled }) => disabled ? '#cccccc' : '#6A42F2'};
  border: none;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  line-height: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    background: #5936e8;
  }
  
  &:disabled {
    opacity: 0.7;
  }
`;